// API related actions
export const FETCHING_ICC_PARAMETERS = '@@toyota/FETCHING_ICC_PARAMETERS';
export const FETCHED_ICC_PARAMETERS = '@@toyota/FETCHED_ICC_PARAMETERS';
export const FETCHED_ICC_PARAMETERS_FAILED = '@@toyota/FETCHED_ICC_PARAMETERS_FAILED';
export const SAVING_ICC_PARAMETERS = '@@toyota/SAVING_ICC_PARAMETERS';
export const SAVED_ICC_PARAMETERS = '@@toyota/SAVED_ICC_PARAMETERS';
export const SAVED_ICC_PARAMETERS_FAILED = '@@toyota/SAVED_ICC_PARAMETERS_FAILED';
export const FETCHING_ICC_PARAMETERS_BY_PROVIDER = '@@toyota/FETCHING_ICC_PARAMETERS_BY_PROVIDER';
export const FETCHED_ICC_PARAMETERS_BY_PROVIDER = '@@toyota/FETCHED_ICC_PARAMETERS_BY_PROVIDER';
export const FETCHED_ICC_PARAMETERS_BY_PROVIDER_FAILED =
'@@toyota/FETCHED_ICC_PARAMETERS_BY_PROVIDER_FAILED';
export const CLEAR_ICC_PARAMETERS_BY_PROVIDER = '@@toyota/CLEAR_ICC_PARAMETERS_BY_PROVIDER';
